import { render, staticRenderFns } from "./PlatDataGridGrade.vue?vue&type=template&id=780c61c0"
import script from "./PlatDataGridGrade.vue?vue&type=script&lang=js"
export * from "./PlatDataGridGrade.vue?vue&type=script&lang=js"
import style0 from "./PlatDataGridGrade.vue?vue&type=style&index=0&id=780c61c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports